
<template>
    <div class="x_box">
        <div class="x_header">
            <button class="btn btn-outline-primary btn-sm" @click="isClickBtnImg">
                <i class="fa fa-plus-circle"></i>
                {{$t('btn.select_img')}}
            </button>
            <button class="btn btn-outline-primary btn-sm" @click="isClickBtnDir">
                <i class="fa fa-folder"></i>
                {{$t('btn.new_directory')}}
            </button>
            <div class="pull-right">
                <b-button-group>
                    <b-button size="sm" variant="primary no-r"><i class="fa fa-table"></i></b-button>
                    <b-button size="sm" variant="outline-primary"><i class="fa fa-th"></i></b-button>
                </b-button-group>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-header">
                <span class="card-title">
                    <i class="fa fa-align-justify"></i>
                    {{ $t('card.image_list') }}
                </span>
                </div>
                <div class="card-body" style="padding: 0;">
                    <Breadcrumb style="width:100%;"/>
                    <div class="container-fluid">
                        <div class="row text-center text-lg-left">
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/pWkk7iiCoDM/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/aob0ukAYfuI/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/EUfxH-pze7s/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/M185_qYH8vg/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/sesveuG_rNo/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/AvhMzHwiE_0/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/2gYsZUmockw/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/EMSDtjVHdQ8/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/8mUEy0ABdNE/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/G9Rfc1qccH4/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/aJeH0KcFkuc/400x300" alt="">
                                </a>
                            </div>
                            <div class="col-lg-2 col-md-4 col-6">
                                <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" src="https://source.unsplash.com/p2TQ-3Bh3Oo/400x300" alt="">
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-footer">
                    <b-pagination
                            size="sm"
                            :total-rows="query.total"
                            :per-page="query.limit"
                            v-model="query.currentPage"
                            :prev-text="$t('page.pre')"
                            :next-text="$t('page.next')"
                            hide-goto-end-buttons
                    />
                </div>
            </div>
        </div>
        <FormModal ref="form" v-on:done="doneHandler" :value="edit" :isUpdate="isedit" :btnIsClick="isClick"/>
    </div>
</template>
<script>
    import  Vue from 'vue'
    import datePicker from 'vue-bootstrap-datetimepicker'
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import Breadcrumb from '../Breadcrumb/Breadcrumb'
    import FormModal from './Form'
    Vue.use(datePicker);
    
    export  default {
        props: {},
        components: { FormModal, Breadcrumb },
        data: function() {
            return {
                query: {
                    currentPage: 1,
                    total: 0,
                    limit: 10
                },
                date: null,
                records: [],
                edit: null,
                isedit: false,
                isClick: ''
            };
        },
        created: function () {

        },
        methods: {
            init: function() {
                var _this = this;
                this.$api().post("category").then(res => {
                    if (res.status == 200) {
                        _this.records = res.data;
                    }
                });
            },
            newHandler: function(){
                this.isedit = false;
                this.edit = null;
                this.$refs.form.$refs.innermodal.show();
            },
            doneHandler: function() {
                this.init();
            },
            isClickBtnImg: function() {
                this.isClick = 'isImg';
                this.newHandler();
            },
            isClickBtnDir: function() {
                this.isClick = 'isDir';
                this.newHandler();
            }
        }

    }
</script>
<style>
    .dropdown-toggle-no-caret:after {
        display: none !important;
    }
</style>
